import { Component, Input, OnDestroy } from '@angular/core';
import { ZusatzangabenDetailEntryMeta } from '../../../../../core/gb-api/model/zusatzangabenDetailEntryMeta';
import { PersonGbVersionDetailEntryMeta } from '../../../../../core/gb-api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ErwerberVeraeussererDetailEntryMeta } from '../../../../../core/gb-api/model/erwerberVeraeussererDetailEntryMeta';
import { BelegAltReferenzObjektTyp } from '../../../../../shared/components/dokulink/dokulinkItem';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { KompaktPersongbComponent } from '../../../../../shared/kompaktdarstellung/persongb/kompakt-persongb.component';
import { KopfdatenelementComponent } from '../../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktBelegComponent } from '../../../../../shared/kompaktdarstellung/beleg/kompakt-beleg.component';
import { ReadMoreComponent } from '../../../../../shared/widgets/read-more/read-more.component';
import { BetragPipe } from '../../../../../shared/pipes/simple/betrag.pipe';
import { DatumPipe } from '../../../../../shared/pipes/simple/datum.pipe';
import { DecimalHochkommaPipe } from '../../../../../shared/pipes/simple/decimalHochkomma.pipe';
import { KompaktGrundstueckPipe } from '../../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { TranslateNamePipe } from '../../../../../shared/pipes/simple/translate-name.pipe';
import { PersonStammMasterDetailEntryMeta } from '../../../../../core/personstamm-api';

@Component({
  selector: 'cap-zusatzangaben-detail',
  templateUrl: './zusatzangaben-detail.component.html',
  styleUrls: ['./zusatzangaben-detail.component.scss'],
  imports: [
    KompaktPersongbComponent,
    KopfdatenelementComponent,
    KompaktBelegComponent,
    ReadMoreComponent,
    TranslatePipe,
    BetragPipe,
    DatumPipe,
    DecimalHochkommaPipe,
    KompaktGrundstueckPipe,
    TranslateNamePipe
  ]
})
export class ZusatzangabenDetailComponent implements OnDestroy {
  @Input()
  zusatzangaben: ZusatzangabenDetailEntryMeta;

  @Input()
  veraeusserer: ErwerberVeraeussererDetailEntryMeta;

  @Input()
  gbPerson: PersonGbVersionDetailEntryMeta;

  @Input()
  referenzObjectId: string;

  @Input()
  referenzObjectArt: BelegAltReferenzObjektTyp;

  @Input()
  auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
  public language: string;
  private subscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private translateService: TranslateService
  ) {
    keysToTranslate<string>([
      'zusatzangabenZuVeraeusserer',
      'Gesamtpreis',
      'DarinEnthalteneZugaben',
      'SonderpreisZugaben',
      'Wertquote',
      'AusserbuchlicherUebergang',
      'Erwerbsangaben',
      'Datum'
    ]);

    this.subscription = this.translateService.onLangChange.subscribe((language) => {
      this.language = language.lang;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
